var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExplore = function SvgExplore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 39,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#explore_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 4,
    y: 1,
    fill: "#fff",
    rx: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#explore_svg__b)",
    fillRule: "evenodd",
    d: "M24.59 6.861a.742.742 0 1 0 1.484-.039.742.742 0 0 0-1.483.04m.793 1.922a1.942 1.942 0 1 1-.102-3.882 1.942 1.942 0 0 1 .102 3.882m-1.898 14.102a.6.6 0 0 1-.848 0l-1.705-1.705a7.65 7.65 0 1 1-.007-10.78l1.712-1.712a.6.6 0 1 1 .848.849l-1.78 1.78a7.6 7.6 0 0 1 1.401 3.654h2.485a.6.6 0 0 1 0 1.2h-2.45a7.6 7.6 0 0 1-1.43 4.09l1.774 1.775a.6.6 0 0 1 0 .849m1.106 1.866a.742.742 0 1 1 1.483-.039.742.742 0 0 1-1.483.039m.69-1.96a1.942 1.942 0 1 0 .102 3.882 1.942 1.942 0 0 0-.102-3.883M9.65 15.792a5.85 5.85 0 1 1 11.7 0 5.85 5.85 0 0 1-11.7 0m6.75-2.25a.9.9 0 0 0-1.8 0v1.35h-1.35a.9.9 0 0 0 0 1.8h1.35v1.35a.9.9 0 1 0 1.8 0v-1.35h1.35a.9.9 0 0 0 0-1.8H16.4zm11.892 2.566a.742.742 0 1 1 1.021-1.076.742.742 0 0 1-1.02 1.076m-.898-1.875a1.942 1.942 0 1 0 2.817 2.673 1.942 1.942 0 0 0-2.817-2.673",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "explore_svg__b",
    x1: 9.872,
    x2: 32.084,
    y1: 7.928,
    y2: 43.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FA5181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA6978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FB806F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#FBAE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#FBAFB1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "explore_svg__a",
    width: 38,
    height: 39,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect1_dropShadow_11425_200486"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11425_200486"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 15,
    result: "effect2_dropShadow_11425_200486"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_11425_200486",
    result: "effect2_dropShadow_11425_200486"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect3_dropShadow_11425_200486"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_11425_200486",
    result: "effect3_dropShadow_11425_200486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_11425_200486",
    result: "shape"
  })))));
};
export default SvgExplore;